import { FC } from "react";
import { Button } from "@src/lib/ui/Button";
import ArrowsExpandIcon from "@src/lib/icons/18px/arrows-expand";
import { cn } from "@src/lib/utils/cn";

type Props = {
  url: string;
  buttonPosition?: "center" | "bottom-right";
};

const ShowViewButtonOverlay: FC<Props> = (props) => {
  return (
    <div
      className={cn(
        "absolute inset-0 flex p-4",
        props.buttonPosition === "center"
          ? "items-center justify-center"
          : "items-end justify-end",
      )}
    >
      <Button
        asChild
        className="border-gray-13 bg-gray-13 text-white hover:border-gray-12 hover:bg-gray-12"
      >
        <a href={props.url} target="_blank" rel="noreferrer">
          View <ArrowsExpandIcon className="size-4" />
        </a>
      </Button>
    </div>
  );
};

export default ShowViewButtonOverlay;
